import { Card } from '@ui/base/card'
import { landingType } from '@ui/landing'
import { ArrowRightIcon } from 'lucide-react'

/** Кому уходит заявка. Города выдуманы — это пример, а не список подключённых фулфилментов. */
const addressees = ['Фулфилмент в Москве', 'Фулфилмент в Казани', 'Фулфилмент во Владимире']

/**
 * Схема рассылки: одна заявка расходится по подходящим фулфилментам. Собрана обычной разметкой,
 * а не рисунком, — тогда подписи остаются нормального размера и на узком экране схема
 * перестраивается в столбик: заявка сверху, стрелка вниз, адресаты под ней.
 */
export const RequestRoutingScheme = () => (
  <Card className="gap-5 px-6 py-6 sm:px-8 sm:py-8">
    <div className="grid items-center gap-4 sm:grid-cols-[minmax(0,1fr)_auto_minmax(0,1.15fr)] sm:gap-7">
      <div className="bg-accent grid gap-1 rounded-xl px-5 py-4">
        <span className={`${landingType.noteText} ${landingType.mutedText}`}>Ваша заявка</span>
        <span className="text-[17px] leading-[1.3] font-medium">одна на всех</span>
      </div>

      <ArrowRightIcon aria-hidden="true" className="text-primary mx-auto size-6 rotate-90 sm:rotate-0" />

      <ul className="grid gap-2.5">
        {addressees.map((addressee) => (
          <li key={addressee} className={`${landingType.bodyText} rounded-xl border px-4 py-3`}>
            {addressee}
          </li>
        ))}
      </ul>
    </div>

    <p className={`${landingType.bodyText} ${landingType.mutedText}`}>
      Заявка уходит только подходящим: схема работы, площадки и география совпали. Остальные её не видят.
    </p>
  </Card>
)
